import {Props} from './model';
import {View} from 'react-native';
import * as React from 'react';
import {images} from '../../../assets/icons';
import {useStyles} from '../../hooks/styles';
import {DeviceSize} from '../../theme/helpers';
import {Text} from '../text';

export default ({text, icon, iconStyle}: Props) => {
  const styles = useStyles(({theme, mediaOnly}) => {
    return {
      item: {
        marginBottom: 15,
        flexDirection: 'row',
        alignItems: 'center',
      },
      itemText: {
        ...mediaOnly(DeviceSize.desktop, theme.fonts.h5Light, theme.fonts.bodySmallLight),
        marginLeft: 8,
        lineHeight: 30,
      },
      icon: {width: 28, height: 28, color: theme.checkMarkList.checkIcon.color},
    };
  });

  const Icon = icon || (images.Check as any);
  return (
    <View style={styles.item}>
      <View style={[styles.icon, iconStyle]}>
        <Icon
          width={iconStyle?.width || styles.icon.width}
          height={iconStyle?.height || styles.icon.height}
          color={iconStyle?.color || styles.icon.color}
        />
      </View>
      <Text style={styles.itemText}>{text}</Text>
    </View>
  );
};
